<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to Settings" @click="$router.push('/settings')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="settings" pageId="cutoff-tax-table" color="white"></help-link>
                    <v-btn v-if="hasEditRights&&!cutoff_settings" dark icon small title="Edit" @click="showEditSettings">
                        <v-icon small>edit</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-progress-linear v-if="loading" indeterminate color="primary" height="3" class="mt-0"></v-progress-linear>
            </v-card>
            
            <v-alert v-if="!loading && cutoff_settings" :value="true" color="info" icon="info" outline dismissible class="mt-8">
                For security purposes, Payroll Settings will not be editable. Please contact support if need assistance.
            </v-alert>  
            <v-alert v-if="!loading && !cutoff_settings" :value="true" color="warning" icon="warning" outline class="mt-8">
                Payroll Setting has not been set. Click Edit icon to update. Pleas note, this is a one time update only.
            </v-alert>

            <v-card v-if="!loading && cutoff_settings" class="elavation-1 mt-5"> 
                <v-toolbar flat height="35px">
                    <span class="font-weight-bold primary--text">CUTOFF SETTINGS</span>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'">
                    <v-flex xs12>
                        <div class="caption grey--text text--darken-1">Cutoff Description</div>
                        <b>{{cutoff_settings.description}}</b>
                    </v-flex>

                    <!-- for monthly -->
                    <v-flex xs12 v-if="!cutoff_settings.second_From && !cutoff_settings.second_To">
                        <div v-if="!cutoff_settings.second_From && !cutoff_settings.second_To">
                            <div class="caption grey--text text--darken-1">Cutoff</div>
                            <b>{{cutoff_settings.first_From}} to {{cutoff_settings.first_To}}</b>
                        </div>
                    </v-flex>
                    
                    <!-- for semi-monthly -->
                    <v-flex xs4 v-if="cutoff_settings.second_From && cutoff_settings.second_To">
                        <div class="caption grey--text text--darken-1">1st Cutoff</div>
                        <b>{{cutoff_settings.first_From}} to {{cutoff_settings.first_To}}</b>
                    </v-flex>

                    <v-flex xs4 v-if="cutoff_settings.second_From && cutoff_settings.second_To">
                        <div class="caption grey--text text--darken-1">2nd Cutoff</div>
                        <b>{{cutoff_settings.second_From}} to {{cutoff_settings.second_To}}</b>
                    </v-flex>
                </v-layout>
            </v-card>

            <v-card v-if="!loading && cutoff_settings" class="elavation-1 mt-5 mb-5"> 
                <v-toolbar flat height="35px">
                    <span class="font-weight-bold primary--text">PAYROLL SETTINGS</span>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'">
                    <v-flex xs4>
                        <div class="caption grey--text text--darken-1">Tax Table Type</div>
                        <b>{{cutoff_settings.taxTableType}}</b>
                    </v-flex>
                    <v-flex xs4>
                        <div class="caption grey--text text--darken-1">Salary Type</div>
                        <b>{{ salaryType }}</b>
                    </v-flex>
                    <v-flex xs4>
                        <div class="caption grey--text text--darken-1">Contribution Schedule</div>
                        <b>{{ contributionScheduleDescription }}</b>
                    </v-flex>
                </v-layout>
            </v-card>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-dialog v-model="dialogSet" persistent width="600">
            <cutoff-settings ref="addEditSchedule" :dialogSet.sync="dialogSet" @send="getCutOffSettings"></cutoff-settings>
        </v-dialog>

        <!-- status messaging component -->
        <status-messaging :page_query_id="pageQueryId" @refresh="updateHandler"></status-messaging>
    </v-layout> 
</template>

<script>

import commonData from '@/common/data'  //for refactor
import cutOffApi from '@/api/cutoff'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import { hasEditRights } from '@/helpers/access-permissions'

export default {     
    name: 'CompanyCutoff',
    metaInfo: {
        title: 'Company Account',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View / Edit Company Cutoff' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'cutoff-settings': () => import('@/components/CutOff/CutOffSettings'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory')
    },   
    data () {
        return {
            error: false,
            errorMessage: '',
            loading: false,
            toggle_view: 4,
            cutoff_settings: null,
            dialogSet: false,
        }
    },
    methods: {    
        updateHandler(data) {
            if (data!=this.$store.state.userId) {
                this.getCutOffSettings(false)
            }
            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        },
        showEditSettings() {
            this.dialogSet = true
        },
        viewCompanySettings() {
            this.$router.push('/company/settings')
        },   
        async getCutOffSettings(show_loading) {
            try {
                this.loading = show_loading
                const response = await cutOffApi.getSettings()
                if (response && response.status == 200) {
                    this.cutoff_settings = response.data.item
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Payroll Settings'
        })

        this.getCutOffSettings(true)
    },
    computed: {
        hasEditRights() {
            return hasEditRights(this.$router.currentRoute.path)
        },
        companyIdStr() {
            return this.$store.state.companyId
        },
        pageQueryId() {
            return `${this.companyIdStr}_cutoff_settings`
        },
        commentsData() {
            if (!this.loading) {
                return {
                    pageQueryId: this.pageQueryId,
                    pageItemCreatedBy: null,
                    pageLink: this.$router.currentRoute.path,
                    pageKey: pageKeys.cutoff,
                    notificationTypeId: notificationTypes.cutoff_settings
                }
            }
        },
        salaryType() {
            if (this.cutoff_settings) {
                return commonData.salary_types.filter(x => x.salaryType == this.cutoff_settings.salaryType)[0].name
            }
        },
        contributionScheduleDescription() {
            if (this.cutoff_settings) {
                return commonData.contribution_schedule_types.filter(x => x.contributionSchedule == this.cutoff_settings.contributionSchedule)[0].name
            }
        },
        isMobile() {
            return window.innerWidth < 600
        },
    }
}
</script>
<style scoped>
.section-layout {
    padding:25px 0px 25px 50px;
}
.section-layout-mobile {
    padding:20px 0px 25px 20px;
}
</style>